import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { NoteService } from '@univacity/angular/datas';
import { Note, NOTE_TYPE } from '@univacity/shared/types';
import { filter, take, takeUntil } from 'rxjs';
import { ModalService } from '../../services';
import { CreateNoteComponent } from '../create-note/create-note.component';
import { DestroyAbleComponent } from '../destroyable/destroyable.component';

@Component({
  selector: 'un-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotesComponent extends DestroyAbleComponent implements OnInit {
  @Input() reference: string;
  @Input() type: NOTE_TYPE;
  @Output() postNote = new EventEmitter<void>();

  faPlusCircle = faPlusCircle;

  totalPages: number;
  notes: Note[];
  limit = 1;

  constructor(
    private noteService: NoteService,
    private cdr: ChangeDetectorRef,
    private modalService: ModalService
  ) {
    super();
  }

  createNote() {
    const modal = this.modalService.create<{ note: Note }>({
      nzTitle: $localize`Add notes`,
      nzContent: CreateNoteComponent,
      nzData: {
        note: {
          type: this.type,
          reference: this.reference,
        },
      },
      nzFooter: null,
      nzWidth: '720px',
    });

    modal.afterClose
      .pipe(
        take(1),
        takeUntil(this.dead$),
        filter((res) => !!res)
      )
      .subscribe(({ note }) => {
        this.notes = [note, ...this.notes];
        this.cdr.detectChanges();
      });
  }

  ngOnInit(): void {
    this.noteService
      .find({
        reference: [this.reference],
        type: [this.type],
        select: ['creator', 'remark', 'updatedAt', 'attachments'],
      })
      .subscribe((res) => {
        this.notes = res.docs;
        this.totalPages = res.totalPages;
        this.cdr.detectChanges();
      });
  }

  async loadMore() {
    const index = this.limit + 1;
    if (this.limit !== this.totalPages) {
      this.noteService
        .find({
          reference: [this.reference],
          type: [this.type],
          select: ['creator', 'remark', 'updatedAt', 'attachments'],
          page: index,
        })
        .subscribe((note) => {
          const newArr = [...this.notes, ...note.docs];
          this.notes = newArr;
          this.limit = index;
          this.cdr.detectChanges();
        });
    } else return;
  }
}
